export default __webpack_public_path__ + "static/video-es-b93189bba70ffdb1ba6ea2b277a2e04f.mp4";